import {
  CREATE_RESTAURANT,
  GET_ALL_RESTAURANTS,
  GET_RESTAURANT_BY_ID,
  FIND_RESTAURANT,
  LOGIN_RESTAURANT,
  DELETE_RESTAURANT,
  GET_RESTAURANT_THEME,
  UPDATE_RESTAURANT_THEME,
  CHANGE_ACCOUNT_DETAIL,
} from "./apiEndpoints";

export const loginRestaurant = async (email, password, frontendPath) => {
  const hasAdmin = frontendPath.includes("admin");
  const response = await fetch(LOGIN_RESTAURANT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Admin-Request": hasAdmin,
    },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    throw new Error("Invalid credentials");
  }

  return await response.json();
};

export const signupRestaurant = async (name, email, password, frontendPath) => {
  const hasAdmin = frontendPath.includes("admin");
  const response = await fetch(CREATE_RESTAURANT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Admin-Request": hasAdmin,
    },
    body: JSON.stringify({ name, email, password }),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(errorResponse.message);
  }

  return await response.json();
};

export const getRestaurantTheme = async (restaurantId) => {
  const response = await fetch(GET_RESTAURANT_THEME(restaurantId));
  if (!response.ok) {
    throw Error("Failed to fetch the theme");
  }
  return response.json();
};

export const updateRestaurantTheme = async (restaurantId, theme) => {
  const response = await fetch(UPDATE_RESTAURANT_THEME(restaurantId), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(theme),
  });

  if (!response.ok) {
    console.error("Failed to update the theme");
  }
};

export const changeAccountDetail = async (
  detailToChange,
  restaurantId,
  newDetail,
) => {
  const response = await fetch(
    CHANGE_ACCOUNT_DETAIL(detailToChange, restaurantId, newDetail),
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(
      errorResponse.message || `Failed to change ${detailToChange}`
    );
  }

  const updatedRestaurant = await response.json();
  return updatedRestaurant;
};
